module.exports = __webpack_public_path__ + "static/media/siuuu.10567878.mp3";